import { Company, Policy } from "@deathstar/types/northstar";
import { Square2StackIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import { useSnackbar } from "../hooks/useSnackbar";

export function PolicyTerm({ policy, company }: { policy: Policy; company?: Company }): JSX.Element {
    return (
        <div>
            <div className="flex w-max flex-shrink-0 items-center gap-1 italic text-gray-400 hover:text-gray-400">
                <span className="whitespace-nowrap text-sm tracking-wide text-gray-400">#{policy.number}</span>
                <Tooltip title="Copy to clipboard">
                    <button
                        className="rounded-full p-1 hover:bg-gray-100"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard
                                .writeText(policy.number)
                                .then(() => {
                                    useSnackbar.add("Copied to clipboard", { variant: "success" });
                                })
                                .catch(() => {
                                    useSnackbar.add("Could not copy. Please try again.", { variant: "warning" });
                                });
                        }}
                    >
                        <Square2StackIcon className="h-4 w-4" />
                    </button>
                </Tooltip>
            </div>
            {company && company.name !== policy.firstNamedInsured && (
                <p className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap font-medium text-navigator-blue">
                    {policy.firstNamedInsured}
                </p>
            )}
            <p>
                {policy.effectiveDate
                    ? moment(policy.effectiveDate.toISOString().substring(0, 10), "YYYY-MM-DD", true).format("MM/DD/YY")
                    : "TBD"}{" "}
                -{" "}
                {policy.expirationDate
                    ? moment(policy.expirationDate.toISOString().substring(0, 10), "YYYY-MM-DD", true).format("MM/DD/YY")
                    : "TBD"}
            </p>
            {policy.cancelEffectiveDate && (
                <p className="text-red-600">
                    Cancel: {moment(policy.cancelEffectiveDate.toISOString().substring(0, 10), "YYYY-MM-DD", true).format("MM/DD/YY")}
                </p>
            )}
        </div>
    );
}
